import React, { useState } from 'react'
import { Text, Button } from '@primer/react-brand'
import Container from './Container'
import LensMark from './landing/LensMark'
import { CivicLensWordmark } from '../../components/Shared/CivicLensBrand'

const NAV = [
  { href: '#how-it-works', label: 'How it works' },
  { href: '#features', label: 'What you can do' },
  { href: '#who', label: 'Who it is for' },
  { href: '#pricing', label: 'Pricing' },
  { href: '#faq', label: 'FAQ' },
]

const linkStyle = {
  textDecoration: 'none',
  color: 'var(--brand-color-text-default)',
}

// Sticky, translucent, hairline-bordered. Sits over the dark hero, so it is
// deliberately light-on-light: the page's first band of contrast is the hero,
// not the chrome above it.
const Header = ({ signInPath = '/sign-in', signUpPath = '/sign-up', currentUser }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  const accountLink = currentUser
    ? { href: '/monitoring', label: 'Open CivicLens' }
    : { href: signInPath, label: 'Sign in' }

  return (
    <header
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 100,
        background: 'var(--brand-color-canvas-default)',
        borderBottom: '1px solid var(--brand-color-border-default)',
      }}
    >
      <Container
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingTop: '14px',
          paddingBottom: '14px',
          gap: '16px',
        }}
      >
        <a href="/" aria-label="CivicLens home" style={{ ...linkStyle, display: 'inline-flex', alignItems: 'center', gap: '10px' }}>
          <LensMark size={26} />
          <CivicLensWordmark fontSize={20} />
        </a>

        <nav className="desktop-nav" aria-label="Primary" style={{ display: 'flex', gap: '28px', alignItems: 'center' }}>
          {NAV.map(({ href, label }) => (
            <a key={href} href={href} style={linkStyle}>
              <Text size="200">{label}</Text>
            </a>
          ))}
        </nav>

        <div className="desktop-nav" style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
          <a href={accountLink.href} style={linkStyle}>
            <Text size="200">{accountLink.label}</Text>
          </a>
          <Button as="a" href={signUpPath} variant="primary" size="medium">Get started</Button>
        </div>

        <button
          type="button"
          className="mobile-menu-btn"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-expanded={mobileMenuOpen}
          aria-controls="mobile-nav"
          aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
          style={{
            display: 'none',
            background: 'none',
            border: '1px solid var(--brand-color-border-default)',
            borderRadius: '6px',
            color: 'var(--brand-color-text-default)',
            fontSize: '18px',
            lineHeight: 1,
            cursor: 'pointer',
            padding: '8px 10px',
          }}
        >
          {mobileMenuOpen ? '✕' : '☰'}
        </button>
      </Container>

      {mobileMenuOpen && (
        <nav
          id="mobile-nav"
          className="mobile-nav"
          aria-label="Primary"
          style={{
            display: 'none',
            flexDirection: 'column',
            padding: '8px 24px 20px',
            borderTop: '1px solid var(--brand-color-border-default)',
            background: 'var(--brand-color-canvas-default)',
          }}
        >
          {[...NAV, accountLink].map(({ href, label }) => (
            <a key={href} href={href} onClick={() => setMobileMenuOpen(false)} style={{ ...linkStyle, padding: '12px 0', borderBottom: '1px solid var(--brand-color-border-muted)' }}>
              <Text size="300">{label}</Text>
            </a>
          ))}
          <Button as="a" href={signUpPath} variant="primary" size="medium" block style={{ marginTop: '16px' }}>
            Get started
          </Button>
        </nav>
      )}
    </header>
  )
}

export default Header
